import {
    selectClone,
    selectData,
    selectIdentifiers,
    selectSelectedHash,
} from "redux/reducers/entities/prerequisites/selectors"

export const distributeState = action => (state, payload) => {
    const clone = selectClone(state)
    const { data, identifiers, ...newState } = action(
        { ...state, ...clone },
        payload,
    )

    return {
        ...state,
        ...newState,
        clone: {
            ...clone,
            data,
            identifiers,
        },
    }
}

export const createPrerequisite = (state, { result, originalPayload }) => {
    const { hash: prerequisiteHash } = result
    const { prerequisite } = originalPayload
    const oldData = selectData(state)
    const oldIdentifiers = selectIdentifiers(state)

    return {
        ...state,
        isLoading: false,
        loadingError: null,
        data: {
            ...oldData,
            [prerequisiteHash]: {
                prerequisiteHash,
                ...prerequisite,
            },
        },
        identifiers: [prerequisiteHash, ...oldIdentifiers],
    }
}
export const updatePrerequisite = (state, { originalPayload }) => {
    const { prerequisite } = originalPayload
    const oldData = selectData(state)
    const oldPrerequisite = oldData[prerequisite?.prerequisiteHash]

    return {
        ...state,
        isLoading: false,
        loadingError: null,
        data: {
            ...oldData,
            [prerequisite?.prerequisiteHash]: {
                ...oldPrerequisite,
                ...prerequisite,
            },
        },
    }
}

export const deletePrerequisite = (state, { originalPayload }) => {
    const { prerequisite } = originalPayload
    const data = { ...selectData(state) }
    const oldIdentifiers = selectIdentifiers(state)
    const selectedHash = selectSelectedHash(state)

    delete data[prerequisite?.prerequisiteHash]
    const identifiers = oldIdentifiers.filter(
        hash => hash !== prerequisite?.prerequisiteHash,
    )

    return {
        ...state,
        isLoading: false,
        loadingError: null,
        identifiers,
        data: {
            ...data,
        },
        selectedHash:
            prerequisite?.prerequisiteHash === selectedHash
                ? null
                : selectedHash,
    }
}
